
import Vue from "vue";
import { generateScores, countdownSecondsFilter } from "@/util/score_util";
import { RECENT_LINEUPS } from "@/data/boss_lineups";
import { Boss } from "@/models/boss";
import BossLineupList from "@/components/BossLineupList.vue";

const bossToChinese = {
  "Dominator of Wolves (Andrius, wolf)": ["奔狼的领主", "奔狼", "北风狼"],
  Assaka: ["阿湿波", "asb"],
  "Argent Knight: Artemis (AKA)": ["月魂"],
  Benares: ["贝纳勒斯", "贝贝龙", "龙"],
  "Bright Knight - Excelsis (BKE)": ["月魄", "幽兰戴尔"],
  "Couatl: Revenant": ["量子帝王", "泥鳅"],
  "Cursed Soul": ["姬子", "被诅咒的英魂"],
  "Dark Jixuanyuan (DXY, DJXY)": ["皮皮马", "马"], // "姬麟·黑"],
  "Death Web + Gigant (Abyss only)": ["蜘蛛泰坦"],
  "Diabolic Kevin": ["凯文", "凯文 - 卡斯兰娜"],
  Doom: ["沉灵", "湮灭沉灵"],
  "Double Wendy (all the way) (Abyss only)": ["双温蒂"],
  Elysia: ["爱莉希雅", "爱莉", "爱"],
  "Emperor (Abyss only)": ["帝王"],
  "False God Otto Apocalypse (FGO)": ["伪神", "伪神奥托", "奥托"],
  "Herrscher of the Void (God Kiana, GK, HoV)": ["空之律者", "女王"],
  Heimdall: ["海姆达尔", "海胖", "胖大海"],
  Hellmaru: ["狐狸", "绯狱丸"],
  "HoD Minion (HoD)": ["千律", "乌合之众"],
  "Herrscher of Sentience (HoS)": ["识之律者"],
  "HOMU (King, Emperor, Magician, Performer)": ["吼姆"],
  Huodou: ["祸斗"],
  "Husk: Existentialism (flower)": ["虚数花", "虚树摊骸-存在主义"],
  "Husk: Mysticism (bull)": ["牛牛", "神秘主义"],
  "Husk: Nihilius (clock)": ["虚树神骸", "lzx"],
  "Jizo Mitama": ["地藏", "地藏御魂"],
  Kallen: ["卡莲"],
  Kalpas: ["千劫", "杰哥", "劫哥", "千师傅"],
  Kasumi: ["八重霞"],
  Kosma: ["科斯魔"],
  "Li Sushang": ["李素裳"],
  "Mexicatl: Umbreist (quantum ball)": ["球", "量子军团"],
  "MHT-3 Pax (tank)": ["MHT", "和平使者", "坦克"],
  "MHT-3B Nirvana (new tank, also SSS tank)": ["MHT-3B", "天堂使者", "坦克"],
  "MHT-3C Retaliator (no transition abyss tank)": ["MHT-3C", "惩戒使者", "坦克"],
  Mobs: ["群聚"],
  "MR-06X Hephaestus": ["赫菲斯托斯", "灭火器"],
  "Otto Apocalypse (Shield Otto)": ["盾奥托", "奥托"],
  Padrino: ["教父"],
  Parvati: ["冰猪", "帕凡提"],
  "Pishacha (Slime, Blob)": ["毕舍遮"],
  Rimestar: ["冰律", "陨冰之律者"],
  "RPC-6626": ["飞机", "RPC - 6626"],
  "Shadow Knight (SK)": ["月轮"],
  "Son of Darkness (Abyss only)": ["黑夜之子"],
  "Titan + Hierophant (soul link mobs) (Abyss only)": ["关底", "双灵魂链接", "红莲泰坦"],
  "Tonatiuh (lobster)": ["托纳提乌", "龙虾"],
  "Wendy + Ganesha (Abyss only)": ["猪温"],
  "Vill-V": ["维尔薇", "V2V"],
  "Opaque Shadow (quantum whale)": ["蔽光之影"],
  "Nocturnal Knight (blood thorn)": ["煌夜骑士"],
  Aponia: ["阿波尼亚", "阿波"],
  "Wardens of Tower (Black Wine of Theramenes, White Sword of Damocles)": ["塔之钳锆", "黑白双煞"],
  "Cruising Tribunal": ["巡航审判团"],
  "Herrscher of Corruption (HoC, Elysia)": ["侵蚀"],
  "Herrscher of Ice (HoI)": ["冰律"],
  "Flying Fish: Patrol Force": ["飞鱼", "游弋集群", "泥鳅"],
  "Alien Guard - Supplement": ["星尘戍卫", "异星肃卫"],
  "Meteoroid: Guaymas": ["瓜伊马斯", "星尘龙虾"],
  "Beast of Sacrifice (Duonigue)": ["殉死之兽"],
  Raven: ["渡鸦"],
  Mobius: ["梅比乌斯"],
  "Meteoroid Fusion: Epernay": ["奈埃尔"],
  "Valrahal (Quantum Pig)": ["量子猪", "瓦拉哈"],
  "Sprout of Wishing": ["愿之芽"],
  "Vita: Sea's Depths": ["薇塔", "量子薇塔"],
  "Bygone Deliverance (Kevin)": ["戒世遗光", "凯文"],
  "Sa: Wheel of Transcendence": ["娑"],
  Lantern: ["灯"],
};

const valkToChinese = {
  "White Comet (*WC, Kiana)": ["白"],
  "Crimson Impulse (*CI, Mei)": ["绯"],
  "Valkyrie Chariot (*VC, Bronya)": ["战"],
  "Valkyrie Ranger (*VR, Kiana)": ["游"],
  "Valkyrie Bladestrike (*VB, Mei)": ["强"],
  "Yamabuki Armor (*YA, Bronya)": ["山"],
  "Divine Prayer (*DP, Kiana)": ["圣"],
  "Shadow Dash (*SD, Mei)": ["影"],
  "Snowy Sniper (*SS, Bronya)": ["雪"],
  "Knight Moonbeam (*KMB, Kiana)": ["月"],
  "Lightning Empress (*LE, Mei)": ["鬼"],
  "Dimension Breaker (*DB, Bronya)": ["次"],
  "Battle Storm (*BS, Himeko)": ["疾"],
  "Scarlet Fusion (*SF, Himeko)": ["深"],
  "Valkyrie Triumph (*VT, Himeko)": ["凯"],
  "Blood Rose (*BR, Himeko)": ["玫"],
  "Gyakushinn Miko (Miko, Yae Sakura)": ["逆"],
  "Goushinnso Memento (Meme, Yae Sakura)": ["勿"],
  "Valkyrie Pledge (*VP, Theresa)": ["誓"],
  "Violet Executor (*VE, Theresa)": ["紫"],
  "Sakuno Rondo (*SR, Theresa)": ["樱"],
  "Wolf's Dawn (*WD, Bronya)": ["银"],
  "Black Nucleus (*BN, Bronya)": ["黑"],
  "Flame Sakitama (*FS, Yae Sakura)": ["炎"],
  "Celestial Hymn (*CH, Theresa)": ["神"],
  "Valkyrie Accipiter (*VA, Fu Hua)": ["迅"],
  "Phoenix (*PX, Fu Hua)": ["炽"],
  "Ritual Imayoh (*RI, Kallen)": ["今"],
  "Night Squire (*NS, Fu Hua)": ["白"],
  "Sixth Serenade (*6S, Kallen)": ["六"],
  "Luna Kindred (*LK, Luna, Theresa)": ["月", "初"],
  "Shadow Knight (*SK, Fu Hua)": ["轮"],
  "Sundenjager (*SJ, Kallen)": ["原罪"],
  "Kreigsmesser (*KMS, Himeko)": ["极"],
  "Herrscher of the Void (*GK, *HoV, *HV, God Kiana)": ["律"],
  "Umbral Rose (*UR, Rita)": ["黯"],
  "Vermillion Knight: Eclipse (*VKE, Himeko)": ["真"],
  "Striker Fulminata (*SF, Mei)": ["强袭"],
  "Phantom Iron (*PI, Rita)": ["狗"],
  "Argent Knight: Artemis (*AKA, Rita)": ["月魂"],
  "Drive Kometa (*DK, Bronya)": ["山"],
  "Blueberry Blitz (*BB, Liliya)": ["蓝"],
  "Molotov Cherry (*MC, Rozaliya)": ["粉", "孤儿队"],
  "Swallowtail Phantasm (*SP, Seele)": ["幻海梦蝶", "希"],
  "Void Drifter (*VD, Kiana)": ["游"],
  "Herrscher of Reason (*HoR, *HR, Bronya)": ["理", "律鸭"],
  "Twilight Paladin (*TP, Theresa)": ["紫"],
  "Hawk of the Fog (*HF, Fu Hua)": ["迅", "迅雷", "雾都迅羽"],
  "Stygian Nymph (*SN, Seele)": ["黑希", "希"],
  "Darkbolt Jonin (*DJ, Yae Sakura)": ["夜隐重霞", "雷八"],
  "Azure Empyrea (*AE, Fu Hua)": ["云", "墨", "云墨丹心"],
  "Valkyrie Gloria (*VG, Durandal)": ["荣光", "女武神·荣光"],
  "Bright Knight: Excelsis (*BKE, Durandal)": ["月魄", "辉骑士月"],
  "Starlit Astrologos (*SA, Kongming, Theresa)": ["朔夜观星", "观"],
  "Herrscher of Thunder (*HoT, *HT, Mei)": ["雷", "雷律", "雷之律者"],
  "Danzai Spectramancer (*DS, Mei)": ["影", "断罪影舞"],
  "Fallen Rosemary (*FR, Rita)": ["迷", "失落迷迭"],
  "Fervent Tempo Delta (*FTD, Rozaliya)": ["狂热蓝调", "粉"],
  "Dea Anchora (*DA, Durandal)": ["星", "不灭星锚", "锚"],
  "Blazing Hope (*BH, Asuka)": ["明日香"],
  "Herrscher of Sentience (*HoS, *HS, Fu Hua)": ["识", "识之律者", "识律"],
  "Haxxor Bunny (*HB, Bronya)": ["骇兔", "迷城骇兔"],
  "Starchasm Nyx (*Nyx, Veliona, Seele)": ["魇夜星渊", "冰希"],
  "Prinzessin der Verurteilung! (*PV, Fischl)": ["皇", "小艾咪", "皇女"],
  "Herrscher of Flamescion (*HoFs, *HFs, Kiana)": ["薪", "炎", "萤火虫", "薪炎之律者"],
  "Miss Pink Elf (*MPE, Elysia)": ["爱莉希雅", "爱莉", "爱"],
  "Infinite Ouroboros (*IO, Mobius)": ["无限·噬界之蛇", "噬界", "蛇主"],
  "Midnight Absinthe (*MA, Raven)": ["午夜苦艾", "渡鸦"],
  "Sweet 'n' Spicy (*SnS, Carole)": ["卡", "卡萝尔", "甜辣女孩"],
  "Silverwing: N-EX (*SW, Bronya)": ["大鸭", "次", "翼"],
  "Palatinus Equinox (*PE, Durandal)": ["天", "天元", "天元骑英"],
  "Spina Astera (*SpA, Rita)": ["星", "星棘", "缭乱星棘"],
  "Reverist Calico (*RC, Pardofelis)": ["猫"],
  "Disciplinary Perdition (*DP, *DiP, Aponia)": ["阿", "阿波尼亚"],
  "Golden Diva (*GD, Eden)": ["伊", "伊甸"],
  "Starry Impression (*SI, Griseo)": ["格", "格蕾修"],
  "Helical Contraption (*HC, Vill-V)": ["维尔薇", "V2V"],
  "Herrscher of Human: Ego (*HH, *HoH, *HoHE, Elysia)": ["人", "爱猫兔", "爱律"],
  "Jade Knight (*JK, Li Sushang)": ["李", "李素裳", "玉骑士月痕"],
  "Chrono Navi (*CN, Ai Hyperion)": ["爱", "爱衣"],
  "Herrscher of Truth (*HoTr, *HTr, Bronya)": ["真理", "真"],
  "Herrscher of Finality (*HoFi, *HFi, Kiana)": ["终"],
  "Herrscher of Origin (*HoO, *HO, Mei)": ["始"],
  "Herrscher Trio (*HFi Kiana, *HO Mei, *HTr Bronya)": ["虚三家"],
  "Valkyrie Quicksand (*VQ, Susannah)": ["苏", "苏珊娜", "苏莎娜", "热砂", "女武神・热砂"],
  "Dreamweaver (*DW, Misteln, Hare)": ["羽", "羽兔"],
  "Terminal Aide 0017 (*TA, Prometheus)": ["普"],
  "Sugary Starburst (*SSt, *SSb, Shigure Kira)": ["时", "糖露星霜"],
  "Herrscher of Rebirth (*HoRb, *HRb, Seele)": ["希", "死生之律者"],
  "Miracle Magic Girl (*MMG, Sirin)": ["西", "西琳"],
  "Lunar Vow: Crimson Love (*LV, Luna, Theresa)": ["月", "月下"],
  "Cosmic Expression (*CE, Griseo)": ["格"],
  "Fenghuang of Vicissitude (*FV, *FoV, Fu Hua)": ["符", "符华", "崩落符华"],
  "Deepspace Anchor: First Light (*FL, *DAFL, Senadina)": ["希", "希娜", "希娜迪雅"],
  "Valkyrie Boltstorm (*VBs, Helia)": ["赫"],
  "Valkyrie Blastmetal (*VBm, Coralie)": ["科"],
  "Senadina Trio/Mars Trio (*FL Senadina, *VBs Helia, *VBm Coralie)": ["星三家"],
  "Mad Pleasure: Shadowbringer (*MP, *MPS, Thelema)": ["瑟"],
  "Lone Destruction: Shadowchaser (*LD, *LDS, Lantern)": ["灯"],
  "Jovial Deception: Shadowdimmer (*JD, *JDS, Songque)": ["松"],
  "Schicksal's Imperative (*SI, *SIm, Theresa)": ["德"],
  "Lone Planetfarer (*LP, Vita)": ["薇"],
  "Thousand-Faced Maestro: Cameo! (*TFM, Sparkle)": ["花"],
  "Reign Solaris (*RS, Durandal)": ["鹅"],
  "Ba-Dum! Fiery Wishing Star (*FWS, Kiana)": ["琪"],
  "Peregrine Sword (*PS, Li Sushang)": ["李"],
  // ELFs & Collaborators
  "Blade Durandal (**BD, **Dudu)": ["星幽"],
  "Elf Elysia (**Ely)": ["星爱"],
  "Kiana Kaslana (**Kiana)": ["星琪"],
  "Project Bunny (**PB)": ["星兔"],
  "Dreamseeker (**DS)": ["寻梦者"],
  "Songque (**Song)": ["松雀"],
  "Serapeum (**Sera)": ["瑟拉"],
  "Theresa Apocalypse (**Teri)": ["德"],
};

const modifiersToChinese = {
  // "F2P / No gacha Gear": ["零蛋"],
  // "2 - 3 pieces of gacha gear": ["低配"],
  // "No JST": ["无叶"],
  // "No Newton": ["无牛"],
  // "No Paganini": ["无帕"],
  // "No Shuijing": ["无水"],
  // "No Zhenyi": ["无贞仪"],
  // "No Turgenev": ["无屠"],
  // "No ELFs": ["无人偶"],
  // "SS LE": ["SS鬼", "2S鬼"],
  // "SS lead skill": ["SS队长技", "2S队长技"],
  // Dirac: ["迪拉克", "狄拉克"],
  "Honkai Impact 3": ["崩坏3"],
  "Beta Test": ["测试服"],
  "Sim battle": ["模拟作战室"],
  "Elysian Realm": ["往世乐土", "往事乐土"],
  "Memorial Arena": ["战场"],
  "Masters": ["高级区"],
  "Exalted": ["终极区"],
  "Q-Singularis": ["量子奇点"],
  "Q-Manifold": ["量子流形"],
  "Superstring Dimension": ["超弦空间"],
  "Red Lotus": ["红莲"],
  Nirvana: ["寂灭"],
  Myriad: ["无限"],
  "1st Place": ["榜一"],
  "Blood Thorn Patch": ["流血"],
  Bloodlust: ["嗜战"],
  Counter: ["克制"],
  Flux: ["流变"],
  Ignited: ["点燃"],
  Lightning: ["雷伤"],
  Physical: ["物理"],
  "Star Shadow": ["影星"],
  Stardust: ["星尘"],
  Starless: ["掩星"],
  Stellar: ["星环"],
  "Stellar Crown": ["星冕"],
  Symphonic: ["交响"],
};

const modifiers = Object.keys(modifiersToChinese).map((m) => ({
  name: m,
  value: false,
}));

const scoresByTime = generateScores(45);

function isMobile(): boolean {
  return window.navigator.userAgent.toLowerCase().includes("mobi");
}

function* combine(arrOfArr: string[][]) {
  const [head, ...tail] = arrOfArr;
  const remainder = tail.length ? combine(tail) : [[]];
  for (const r of remainder) for (const h of head) yield [h, ...r];
}

export default Vue.extend({
  data: function () {
    return {
      selectedBoss: null,
      sssBoss: false,
      selectedValks: [],
      valkInput: null,
      score: null,
      bosses: Object.keys(bossToChinese),
      valks: Object.keys(valkToChinese),
      scores: scoresByTime.map((s) => s.ssScore),
      scoresByTime: scoresByTime,
      modifiers: modifiers,
      lineups: RECENT_LINEUPS,
      googleToggle: false,
      googleToggleBili: true,
    };
  },
  components: { BossLineupList },
  computed: {
    bossNames: function () {
      if (this.selectedBoss === null) {
        return [""];
      }

      if (this.sssBoss) {
        return bossToChinese[this.selectedBoss].map((bossName) => "SSS" + bossName);
      } else {
        return bossToChinese[this.selectedBoss];
      }
    },
    // Some valks have multiple names, make all combos of valk team.
    valkCombos: function () {
      let combos = [""];
      this.selectedValks
        .map((v) => valkToChinese[v])
        .forEach((names) => {
          combos = combos.reduce((acc, curr) => {
            names.forEach((n) => acc.push(curr + n));
            return acc;
          }, []);
        });
      return combos;
    },
    // Converts valk combinations to use the google OR search notation.
    valkCombosGoogle: function () {
      let combos = [];
      this.selectedValks
        .map((v) => valkToChinese[v])
        .forEach((names) => {
          combos.push(`(${names.join("|")})`);
        });
      return combos;
    },
    biliLinks: function () {
      // Static modifiers that go at the end.
      let modifierParams = this.modifiers
        .filter((m) => m.value)
        .map((m) => modifiersToChinese[m.name]);

      if (this.googleToggle) {
        // Google search queries don't need any combinations since they can use the OR operator, so separating this
        // logic out.
        return [
          "https://www.google.com/search?q=" +
            [
              this.selectedBoss ? `(${this.bossNames.join("|")})` : "",
              this.valkCombosGoogle.join(" "),
              modifierParams.length
                ? `(${modifierParams.map((params) => params.join("|")).join(" ")})`
                : "",
              this.score,
              this.googleToggleBili ? "site:https://www.bilibili.com" : "",
            ]
              // Remove empty strings and nulls to avoid extra spaces and weirdness in the output.
              .filter((n) => n)
              .join(" "),
        ];
      }

      if (this.score) {
        modifierParams.push([this.score]);
      }
      // Must have at least one element in each array passed to combine to generate anything.
      modifierParams = modifierParams.length ? modifierParams : [[""]];
      const modifierCombos = Array.from(combine(modifierParams)).map((c: string[]) =>
        c.join(" ").trim()
      );

      const baseUrl = isMobile()
        ? "https://m.bilibili.com/search?keyword="
        : "https://search.bilibili.com/all?keyword=";

      const combinations: string[][] = Array.from(
        combine([this.bossNames, this.valkCombos, modifierCombos])
      );
      return combinations
        .map((c: string[]) => `${baseUrl}${c.join(" ").trim()}`)
        .sort(function (a, b) {
          return a.length - b.length || a.localeCompare(b);
        });
    },
  },
  filters: {
    countdownSeconds: countdownSecondsFilter,
    lineupFormat: function (bosses: Boss[]) {
      return bosses.map((boss, index) => boss.shortName + (index == 0 ? " (up)" : "")).join(", ");
    },
  },
});
